import { ValidatorType } from "anketa-core/base";
import { CommentQuestion } from "anketa-core/command_question";
import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { QuestionsRightsTypes } from "..";

export const setupComment = (
  commentSection: Section,
  idx = 0,
  questionsRights: (q: QuestionsRightsTypes) => void
) => {
  const comment = commentInputGenerator(idx, questionsRights);
  questionsRights(comment);

  commentSection.addChild(comment);
  function onConfigChange() {
    const { createTime, user } = comment.commentValues;

    if (createTime && user) {
      commentSection.removeChangeListener(onConfigChange);
      setupComment(commentSection, idx + 1, questionsRights);
    }
  }

  commentSection.addChangeListener(onConfigChange);
};

export const commentInputGenerator = (
  idx: number,
  questionsRights: (q: QuestionsRightsTypes) => void
): CommentQuestion => {
  const idPrefix = `comment_${idx}`;

  const commentInput = new CommentQuestion(idPrefix, [
    new Translation("en", "New question/note"),
    new Translation("de", "Neuer Frage/Kommentar"),
  ]);
  questionsRights(commentInput);

  commentInput.validator._type = ValidatorType.Markdown;
  return commentInput;
};
